import axios from "axios";
import { gatewayInstance } from "@/server/gateway";
import { GatewayRequestOptions } from "@/server/types";
import { isFocusEnv, FocusSDK } from "@/utils";
import cache from "@/utils/cache";
import { ErrorCode, ResetErrorCode } from "../types";
import events from "../context/events";
export interface RequestOptions extends Partial<Pick<GatewayRequestOptions, "method" | "body">> {
  api: string;
  path?: string;
  params?: { [key: string]: any };
}

export const request = <T = any>(options: RequestOptions) => {
  let janusBaseUrl = gatewayInstance.getBaseUrl();
  return gatewayInstance
    .request<T>({
      api: options.api,
      method: options.method ?? "GET",
      dynamicPath: options.path,
      params: options.params,
      body: options.body,
      headers: {
        platform: isFocusEnv() ? cache?.token?.token?.focusClient || "web" : "web", // todo joyspace api请求 暂时定为web 网关请求headers[x-client]对应的值
        "x-host": janusBaseUrl
      }
    })
    .catch((e) => {
      // console.log(e, 'gatewayInstancegatewayInstancegatewayInstance');
      if (options?.params?.authFolder) {
        const folderId = options?.params?.authFolder;
        events.emit(
          "joyspace:location",
          `/joyspace/error?code=openFolderError${folderId ? "&folderId=" + folderId : ""}`
        );
      }
    })
    .then((data: any) => {
      if (
        options?.api === "joyspace.folder.sub" ||
        options?.api === "joyspace.folder.get" ||
        options?.api === "joyspace.pages.listByTag"
      ) {
        if ((options?.params?.authFolder || !isNaN(options?.params?.tagId)) && data) {
          if (
            data.code === ErrorCode.noPermission ||
            data.code === ResetErrorCode.noPermission ||
            data.code === ResetErrorCode.Delete ||
            data.code === ErrorCode.Delete
          ) {
            const folderId = options?.params?.authFolder;
            const isGroup = options?.params?.isGroup;
            const tagId = options?.params?.tagId;
            if (isGroup) {
              events.emit("groupSpace:setErrCode", data.code);
              events.emit("groupspace.setSearchFolderId", options?.params?.authFolder);
              events.emit("groupspace.searchList.onClose");
            } else {
              events.emit(
                "joyspace:location",
                `/joyspace/error?code=${data.code || data.status}${
                  folderId ? "&folderId=" + folderId : ""
                }${tagId ? "&tagId=" + tagId : ""}`
              );
            }
          } else if (data.code !== "200") {
            const folderId = options?.params?.authFolder;
            events.emit(
              "joyspace:location",
              `/joyspace/error?code=openFolderError${folderId ? "&folderId=" + folderId : ""}`
            );
          }
        }
        return data?.data as T;
      }

      return data as T;
    });
};
